import { Layout } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./jsx/layout/nav/AppRoutes";
import TopHeader from "./jsx/layout/TopHeader.js";
import { MenuList } from "./jsx/layout/nav/MenuList.js";
import FooterBar from "./jsx/layout/FooterBar.js";
import SubMenuBar from "./jsx/layout/SubMenuBar.js";
import { findMenuFromPath } from "./jsx/components/CustomView/menuUtils.js";
import { NotifyProvider, NotifyInitializer } from "./jsx/components/Customs/NotifyProvider.js";
import { filterMenuByPermission } from "./jsx/utils/filterMenuByPermission";
import { captureStaymasterTokenFromUrl } from "./jsx/utils/staymasterHandoff";
import "./jsx/services/axiosAuthInterceptor";

import "./App.css";

const { Content } = Layout;

function App() {
  const location = useLocation();
  const [activeParent, setActiveParent] = useState(null);

  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    captureStaymasterTokenFromUrl();
  }, []);

  useEffect(() => {
    if (!isLoginPage) {
      const visibleMenuList = filterMenuByPermission(MenuList);
      const { parent } = findMenuFromPath(visibleMenuList, location.pathname);
      setActiveParent(parent);
    }
  }, [location.pathname, isLoginPage]);

  return (
    <NotifyProvider>
      <Layout style={{ minHeight: "100vh" }}>
        {!isLoginPage && (
          <>
            <TopHeader
              activeParent={activeParent}
              setActiveParent={setActiveParent}
            />
            <SubMenuBar activeParent={activeParent} />
          </>
        )}

        <Content
          style={{
            margin: isLoginPage ? 0 : 10,
            paddingTop: isLoginPage ? 0 : 5,
            background: isLoginPage ? "#f5f7fb" : "#f7f9fc",
          }}
        >
          <AppRoutes />
        </Content>

        {!isLoginPage && <FooterBar />}
      </Layout>
      <NotifyInitializer />
    </NotifyProvider>
  );
}

export default App;